import { css } from '@emotion/react';

import * as React from 'react';

import gql from 'graphql-tag';

import { Button, Grid, Typography } from '@coursera/cds-core';
import { ChevronNextIcon } from '@coursera/cds-icons';

import withFragments from 'bundles/graphql/components/withFragments';
import TopReviewCards from 'bundles/reviews-common/components/TopReviewCards';
import type { TopReview } from 'bundles/reviews-common/types/reviewsSharedTypes';

import _t from 'i18n!nls/reviews';

type Props = {
  ratings: Array<TopReview>;
  onStarReviewsClick: () => void;
};

const styles = {
  btnStyle: () => css`
    && {
      border: unset;
      background-color: unset;
      color: var(--cds-color-grey-975);
      padding-top: var(--cds-spacing-300);
      padding-bottom: var(--cds-spacing-300);
      font-weight: bold;
    }
  `,
  iconStyle: () => css`
    && {
      position: relative;
      top: var(--cds-spacing-50);
      left: var(--cds-spacing-50);
    }
  `,
};

export const TopRatings: React.FC<Props> = ({ ratings, onStarReviewsClick }) => {
  if (!ratings || !ratings.length) {
    return null;
  }

  return (
    <div className="rc-TopRatings">
      <Typography className="m-y-2" variant="d2">
        {_t('Top reviews')}
      </Typography>
      <TopReviewCards topReviews={ratings} />
      <Grid container className="border-bottom">
        <Button
          variant="ghost"
          size="small"
          icon={<ChevronNextIcon size="small" css={styles.iconStyle} />}
          onClick={onStarReviewsClick}
          className="btn-SeeAllRatings"
          css={styles.btnStyle}
        >
          {_t('See all 5 star reviews')}
        </Button>
      </Grid>
    </div>
  );
};

const TopReviewsQuery = gql`
  fragment TopRatingsFragment on XdpV1_org_coursera_xdp_nostos_NostosXDPReview {
    reviewId
    averageFiveStarRating
    timestamp
    authorName
    comment
  }
`;
export default withFragments({
  topRatings: TopReviewsQuery,
})(TopRatings);
